import { Comment } from "../services/CommentsService";
import { IAddress, ISuperficialAddress } from "./Address";
import { IClient } from "./Client";
import { IPoliceman } from "./Policeman";
import { IProvider } from "./Provider";
import { IReport } from "./Report";
import { ISuperficialClient } from "./SubClient";
import { ITenant } from "./Tenant";
import { IUser } from "./User";
import {
  ISuperficialIVehicle,
  ISuperficialIVehicleProps,
  IVehicle,
} from "./Vehicle";

export type Status =
  | "concluido"
  | "andamento"
  | "cancelado"
  | "aprovacao"
  | "aguardando"
  | "semi-concluido"
  | "aprovacao-km-inicial"
  | "aprovacao-km-final"
  | "aguardando_cancelamento";
   

  // 'aguardando',
  // 'associado',
  // 'andamento',
  // 'aprovacao',
  // 'semi-concluido',
  // 'concluido',

export const OccurrenceWorkingStatus = [
  'andamento', 
  'aprovacao', 
  'semi-concluido', 
  'concluido'
]


export interface IOccurrenceHistory {
  actionType: string;
  active: boolean;
  addressAlterations: string[] | null;
  createdAt: string;
  id: string;
  occurrenceAlterations: string[] | null;
  updatedAt: string;
  vehicleAlterations: string[] | null;
  attendant: IUser;
}

export interface IOccurrence {
  id: string;
  protocol: number;
  numberBO?: string;
  status: Status;
  tracker: string;
  patrimonialType: number;
  lastCoordAddress?: string;
  client: IClient;
  description: string;
  attendant: IUser;
  lastCoordX: number;
  lastCoordY: number;
  createdAt: Date;
  updatedAt: Date;
  history: IOccurrenceHistory[];
  isManual: boolean;
  lastCoords: [number, number][];
  stringLastCoords?: string;
  stringFindCoords?: string;
  findCoords?: [number, number];
  comments: Comment[];
  report?: IReport[];
  workType?: string;
  active: boolean;
  occurrencesSuperficialAddresses: { superficialAddress: ISuperficialAddress };
  superficialVehicle: ISuperficialIVehicle;
  searchDistance?: number;
  superficialContact: {
    active: true;
    id: string;
    createdAt: Date;
    updatedAt: Date;
    contactName: string;
    phoneNumber: string;
  };
  timeRemaining?: string;
  providers?: {
    id: string;
    provider: IProvider;
  }[];
  policemen: {
    id: string;
    policeman: IPoliceman;
  }[];
  tenant?: ITenant;
}

export interface ICreateOccurrence {
  id?: string;
  lastCoords?: [number, number][];
  patrimonialType: number;
  postalCode?: string;
  isManual: boolean;
  street?: string;
  number?: string;
  district?: string;
  uf?: string;
  city?: string;
  coordX?: number;
  coordY?: number;
  numberBO?: string;
  superficialClient?: any;
  superficialAddressId?: string;
  Client: IClient;
  lastCoordX?: number;
  lastCoordY?: number;
  reference?: string;
  workType?: string;
  superficialVehicle?: ISuperficialIVehicleProps;
  superficialClientId?: string;
  policemen?: IPoliceman[];
}

export interface IUpdateOccurrence {
  id: string;
  lastCoords?: [number, number][];
  patrimonialType?: number;
  status?: string;
  superficialClient: string;
  numberBO?: string;
  lastCoordX?: number;
  lastCoordY?: number;
  postalCode?: string;
  policeman?: string;
  street?: string;
  number?: string;
  district?: string;
  uf?: string;
  city?: string;
  reference?: string;
  complement?: string;
  coordX?: number;
  coordY?: number;
  workType?: string;
  superficialAddressId?: string;
  superficialVehicle?: ISuperficialIVehicleProps;
}
export interface IStatistics {
  occurrencesToday: IOccurrencesToday;
  occurrencesThisWeek: IOccurrencesPeriod;
  occurrencesLastYear: IOccurrencesPeriod;
}
interface IOccurrencesToday {
  finished: IOccurrence[];
  approval: IOccurrence[];
  progress: IOccurrence[];
}

export interface IFilteredOccurrences {
  all: IOccurrence[];
  inProgress: IOccurrence[];
  finished: IOccurrence[];
  waiting: IOccurrence[];
}

interface IOccurrencesPeriod {
  vehicle: number[];
  residence: number[];
}
export interface IOccurrencesFilteredByStatus {
  espera?: IOccurrence[];
  concluido?: IOccurrence[];
  andamento?: IOccurrence[];
  cancelado?: IOccurrence[];
  aprovacao?: IOccurrence[];
  aguardando?: IOccurrence[];
  "semi-concluido"?: IOccurrence[];
  "aprovacao-km-inicial"?: IOccurrence[];
  "aprovacao-km-final"?: IOccurrence[];
  "aguardando_cancelamento"?: IOccurrence[];
}
